import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { enviarJson } from "./api";

/* O assistente do portal (tela "Ajuda"): responde dúvida de uso a partir da base de conhecimento.

   A tela não repete regra nenhuma: o servidor decide se há fonte, se a pergunta pede dado de
   cliente e se responde redigido (IA) ou com o trecho do artigo. A tela mostra o que vier — e,
   quando a resposta é recusa, mostra a recusa como recusa, não como erro. */

const esquemaFonte = z.object({
  id: z.string().uuid(),
  titulo: z.string(),
  categoria: z.string().nullable(),
  modulo_chave: z.string().nullable(),
});

const esquemaResposta = z.object({
  encontrou: z.boolean(),
  resposta: z.string(),
  modo: z.enum(["ia", "trechos", "recusa"]),
  fontes: z.array(esquemaFonte),
  motivo_da_recusa: z.enum(["sem_fonte", "dado_de_cliente"]).nullable(),
});
export type RespostaDoAssistente = z.infer<typeof esquemaResposta>;

/** Menos de 3 letras não é pergunta. */
export const MINIMO_DE_LETRAS_DA_PERGUNTA = 3;
export const MAXIMO_DE_LETRAS_DA_PERGUNTA = 300;

/**
 * Pergunta ao assistente. É uma consulta (POST que não muda nada) e por isso `useQuery`: a mesma
 * pergunta não vai duas vezes ao servidor, e a pergunta velha é descartada quando a pessoa segue
 * digitando. Nunca tenta de novo: cada tentativa conta no limite por minuto.
 */
export function useAssistenteDoPortal(pergunta: string) {
  const texto = pergunta.trim().slice(0, MAXIMO_DE_LETRAS_DA_PERGUNTA);
  return useQuery({
    queryKey: ["assistente-do-portal", texto],
    queryFn: ({ signal }) =>
      enviarJson("/assistente-do-portal/perguntas", esquemaResposta, { pergunta: texto }, { signal }),
    enabled: texto.length >= MINIMO_DE_LETRAS_DA_PERGUNTA,
    retry: false,
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}
